module.exports = __webpack_public_path__ + "static/img/13.98d96ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13.jpg
// module id = LQRw
// module chunks = 26